module.exports = __webpack_public_path__ + "img/die2.89ae8799.svg";